import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { supabase } from '../../service/api.tsx'
import About from '../../components/About/About.tsx'
import Card from '../../components/Card/Card.tsx'
import { useLenis } from '../../lenis/LenisProvider.jsx'
import './home.css'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function Home() {
    const [projects, setProjects] = useState([]);
    const location = useLocation();
    const lenis = useLenis();

    useEffect(() => {
        const fetchData = async () => {
            let { data, error } = await supabase
                .from('projects')
                .select("id, name, shortdescription, thumbnail, project_descriptions(description), project_images(img), project_tags(tag)")
                .order('id')
            if (error) console.error(error)
            else setProjects(data)
        }
        fetchData()
    }, [])
    useEffect(() => {
        const trigger = gsap.from('.container-title', {
            opacity: 0,
            y: -30,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: '.container-title',
                start: 'top 85%',
            },
        });
        return () => trigger.scrollTrigger && trigger.scrollTrigger.kill();
    }, []);
    useEffect(() => {
        if (projects.length === 0) return;

        const ctx = gsap.context(() => {
            gsap.utils.toArray('.container-card').forEach((card) => {
                gsap.fromTo(
                    card,
                    { opacity: 0, y: 70 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.9,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: card,
                            start: 'top 88%',
                            toggleActions: 'play none none reverse',
                        },
                    }
                );
            });
        });
        const onImgLoad = () => ScrollTrigger.refresh();
        const imgs = document.querySelectorAll('.container-card img');
        imgs.forEach((img) => img.addEventListener('load', onImgLoad));

        return () => {
            ctx.revert();
            imgs.forEach((img) => img.removeEventListener('load', onImgLoad));
        };
    }, [projects]);
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '');
            const el = document.getElementById(id);
            if (el) {
                setTimeout(() => {
                    if (lenis) lenis.scrollTo(`#${id}`);
                    else el.scrollIntoView({ behavior: 'smooth' });
                }, 80);
            }
        }
    }, [location, lenis]);

    return (
        <div>
            {/* SEO Metadata */}
            <Helmet>
                <title>Romain Danizel - Portfolio Developer FullStack JavaScript Freelance</title>
                <meta name="description" content="Discover my web development projects and me, showcasing my skills in JavaScript, React, Next.js, TypeScript, Mongodb. Available to work for your web projects" />
                <meta name="keywords" content="web development, React, Next.js, JavaScript, portfolio, developer fullstack, developer javascript, freelance" />
                <meta name="author" content="Romain Danizel" />

                {/* Open Graph (OG) for Social Media */}
                <meta property="og:title" content="Romain Danizel - Portfolio" />
                <meta property="og:description" content="Discover my latest web development projects." />
                <meta property="og:image" content="https://zmsyrobplmtyslsehkqt.supabase.co/storage/v1/object/public/Seo//thumbnailPortfolio.jpeg" />
                <meta property="og:url" content="https://www.romaindanizel.com/" />
                <meta property="og:type" content="website" />

                {/* Twitter Card for Social Sharing */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="My Portfolio - Web Projects" />
                <meta name="twitter:description" content="Discover my latest web development projects." />
                <meta name="twitter:image" content="https://zmsyrobplmtyslsehkqt.supabase.co/storage/v1/object/public/Seo//thumbnailPortfolio.jpeg" />
            </Helmet>

            <About />

            <div className="marquee-strip" aria-hidden="true">
                <div className="marquee-track">
                    <span>WEB DEV</span><span className="dot">✦</span>
                    <span>FULL-STACK</span><span className="dot">✦</span>
                    <span>REACT / NODE</span><span className="dot">✦</span>
                    <span>TYPESCRIPT</span><span className="dot">✦</span>
                    <span>NEXT.JS</span><span className="dot">✦</span>
                    <span>WEB DEV</span><span className="dot">✦</span>
                    <span>FULL-STACK</span><span className="dot">✦</span>
                    <span>REACT / NODE</span><span className="dot">✦</span>
                    <span>TYPESCRIPT</span><span className="dot">✦</span>
                    <span>NEXT.JS</span><span className="dot">✦</span>
                </div>
            </div>

            <div className="container-title" id='projects'>
                <div>
                    <span className="eyebrow">Selected Work</span>
                    <h2 className="title">Mes projets</h2>
                </div>
                <p className="section-intro">Quelques projets que j'ai conçus et développés, avec le code et les démos associés.</p>
            </div>

            <div className="container container-projects">
                {projects.map((project) => (
                    <div className="container-card" key={project.id}>
                        <Card
                            id={project.id}
                            name={project.name}
                            img={project.thumbnail}
                            tags={project?.project_tags}
                            description={project.shortdescription}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
